import {CircularProgress} from '@material-ui/core';
import styled from 'styled-components';

const ToastSpinner = styled(CircularProgress)`
    max-width: 15px;
    max-height: 15px;
    vertical-align: middle;
    color: #f57c00;
`;

export default ToastSpinner;